import type { MeUser } from "schemas";
import { useLiteSiteStore } from "../store";

export function setUser(user: MeUser) {
  useLiteSiteStore.setState(() => ({ user, authorized: true }));
}
